module.exports = __webpack_public_path__ + "static/cta-do-e6d30050b3117d1573795c265f7bbb94.png";